/** iOS keyboards resize visualViewport while 100dvh can retain the layout viewport height. */
export function trackMobileDialogViewport(target: Window | undefined, root?: HTMLElement): () => void {
    const viewport = target?.visualViewport;
    if (!viewport || !root) return () => {};
    let frame: number;
    let previousHeight = viewport.height;
    const revealFocusedField = () => {
        const input = root.ownerDocument.activeElement as HTMLElement;
        const content = input?.closest('.p-dialog-content') as HTMLElement;
        if (!content) return;
        const fieldBounds = input.getBoundingClientRect();
        const bounds = content.getBoundingClientRect();
        if (fieldBounds.bottom > bounds.bottom) content.scrollTop += fieldBounds.bottom - bounds.bottom + 8;
        else if (fieldBounds.top < bounds.top) content.scrollTop -= bounds.top - fieldBounds.top + 8;
    };
    const update = () => {
        const shrunk = viewport.height < previousHeight;
        previousHeight = viewport.height;
        root.style.setProperty('--dialog-visible-height', `${viewport.height}px`);
        root.style.setProperty('--dialog-visible-top', `${viewport.offsetTop}px`);
        if (shrunk) {
            target.cancelAnimationFrame?.(frame);
            frame = target.requestAnimationFrame?.(revealFocusedField);
        }
    };
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    update();
    return () => {
        target.cancelAnimationFrame?.(frame);
        viewport.removeEventListener('resize', update);
        viewport.removeEventListener('scroll', update);
        root.style.removeProperty('--dialog-visible-height');
        root.style.removeProperty('--dialog-visible-top');
    };
}
